/* eslint-disable class-methods-use-this */
/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Bob Olde Hampsink <bob@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import * as Turbo from '@hotwired/turbo';

/**
 * Nav controller.
 */
export default class extends Controller {
  adapter;

  /**
   * Initialize.
   */
  initialize() {
    this.adapter = Turbo.navigator.delegate.adapter;
  }

  /**
   * Connect.
   */
  connect() {
    document.addEventListener('turbo:before-fetch-request', this.startProgress.bind(this));
    document.addEventListener('turbo:before-fetch-response', this.finishProgress.bind(this));
    document.addEventListener('turbo:before-frame-render', this.reset.bind(this));
  }

  /**
   * Disconnect.
   */
  disconnect() {
    document.removeEventListener('turbo:before-fetch-request', this.startProgress.bind(this));
    document.removeEventListener('turbo:before-fetch-response', this.finishProgress.bind(this));
    document.removeEventListener('turbo:before-frame-render', this.reset.bind(this));
  }

  /**
   * Start Turbo progress bar.
   *
   * @param {Event} e
   */
  startProgress(e) {
    if (!(e.target instanceof HTMLElement)) return;

    if (e.target.getAttribute('data-turbo-action') === 'advance') {
      this.adapter.formSubmissionStarted(this);
    }
  }

  /**
   * Finish Turbo progress bar.
   */
  finishProgress() {
    this.adapter.formSubmissionFinished(this);
  }

  /**
   * Add has-scrolled class to element on scroll.
   */
  onScroll() {
    const scrollTop = window.scrollY;
    const distance = 60;
    this.element.classList.toggle('has-scrolled', scrollTop >= distance);
  }

  /**
   * Reset nav state.
   *
   * @param {Event} e
   */
  reset(e) {
    if (e.detail.newFrame.id === 'main' || e.detail.newFrame.id === 'main-contact-form') {
      window.scrollTo(0, 0);
    }
  }
}
